var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',_vm._g(_vm._b({ref:"input",staticClass:"v-input",class:{ 'v-input--error': _vm.error },attrs:{"inputmode":"numeric"},domProps:{"value":_vm.inputValue}},'input',_vm.$attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }